import "core-js/stable";
import React, { Component, createRef } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import Messages from "../common/msg/messages";
import Concurso from "../concurso/concurso";

import { newSession } from "../reducers/usuario/usuarioActions";
import {
  setCurrentTemplate,
  setIsNewDesign,
} from "../reducers/settings/settingsActions";

import "../common/template/dependencies";
import "../common/template/custom.scss";
import "../common/themes/mixbet.scss";
import NewApp from "../newDesign/newApp";
import { loadColorTemplate } from "../styles/templates";
import templateDefault from "../styles/templates/default";

import Error from "./error";
import {
  ErrorContext,
  ErrorModal,
  ErrorProvider,
} from "../rifa/components/errorModal";
import { deleteState, saveState } from "../modules/localStorage";
import { emitIntent } from "../newDesign/utils/emitIntent";
import { insertAnalyticsTags } from "../utils/analytics";

// import 'font-awesome/css/font-awesome.min.css'

class App extends Component {
  constructor(props) {
    super(props);
    const params = new URL(document.location.href).searchParams;
    this.style = params.get("style");
    this.preSelected = params.get("page");

    this.state = {
      isThemeSeted: false,
    };

    if (this.style) {
      try {
        this.style = atob(this.style);
      } catch (ex) {
        console.error("invalid custom style");
        this.style = null;
      }
    }
    this.topRef = createRef(null);
    this.componentRef = createRef(null);

    window.addEventListener("message", (message) => {
      const data = message.data;
      this.setState({ isThemeSeted: true });
      if (data.type === "template") {
        const template = loadColorTemplate(data.data);

        if (template) {
          template.apply();
        }
      }
    });
  }

  componentWillMount() {
    const params = new URLSearchParams(this.props.location.search);
    let clientId = params.get("clientId");
    let siteId = params.get("siteId");
    let ponto = params.get("ponto");
    let operador = params.get("operador");
    let token = params.get("token");
    let userId = params.get("userId");
    let sessionId = params.get("sessionId");
    let appTheme = params.get("theme");
    let hasNewDesign = "true"; //params.get("newDesign");
    let CID = params.get("CID");
    let hasPreTicket = params.get("preticket");

    //SOMENTE PARA DEBUG
    if (clientId == undefined || clientId == 0) clientId = 1;
    if (ponto == undefined || ponto == "" || ponto == "undefined") ponto = "";
    if (operador == undefined || operador == "" || operador == "undefined")
      operador = "";
    //if (token == undefined || token == '') token = 'TESTEDEV';
    if (token == undefined || token == "") token = "";
    if (userId == undefined || userId == "") userId = "";
    if (sessionId == undefined || sessionId == "") sessionId = "";
    // if (appTheme == undefined || appTheme == '') appTheme = 'sitebets';
    if (appTheme == undefined || appTheme == "") appTheme = "default";
    if (hasPreTicket == undefined || hasPreTicket == "") hasPreTicket = false;

    this.setState({
      ProdutoID: 666,
      appTheme: appTheme,
      hasNewDesign: hasNewDesign === "true",
      session: null,
    });

    this.props.setCurrentTemplate(appTheme);
    this.props.setIsNewDesign(hasNewDesign === "true");

    setTimeout(() => {
      this.props.newSession(
        clientId,
        "",
        token,
        sessionId,
        ponto,
        operador,
        CID,
        (session) => {
          this.setState({
            session,
          });

          if (session && !window.gtag) {
            insertAnalyticsTags(session.vchTagGoogleAnalytics || '', session.vchTagPixel || '');
          }

          emitIntent("update_newsession_loaded", {});
          emitIntent("update_footer", {
            email: session.VchEmail,
            whatsapp: session.VchWhatsApp,
            meioPagamento: session.arrMeioPagamento
          });
        },
        siteId
      );
    }, 0);

    setInterval(() => {
      const element = this.componentRef.current; // Acessar o nó DOM do componente
      if (element) {
        const height = element.scrollHeight;

        emitIntent("adjust_height", { height });
      }
    }, 1000);

    if (!this.state.isThemeSeted) {
      const template = loadColorTemplate(templateDefault);
      if (template) {
        template.apply();
        this.setState({ isThemeSeted: true });
      }
    }
  }

  componentDidMount() {
    window.addEventListener("message", (event) => {
      const { data, type } = event.data;
      if (type === "user") {
        if (data === undefined) deleteState(type);
        else saveState(data, type);
      }
    });
  }

  render() {
    const { intCodigoRetorno } = this.props.objUser;
    const contentWrappperClass = `content-wrapper ${this.state.appTheme}-container`;

    if (!this.state.session) {
      return <Error message="Carregando..." loading />;
    }

    if (this.state.session.intCodigoRetorno > 0 || intCodigoRetorno > 0) {
      return <Error message={this.state.session.strErrorMessage} loading />;
    }

    return (
      <div ref={this.componentRef}>
        <ErrorProvider scrollY={scrollY}>
          <ErrorContext.Consumer>
            {({
              showErrorModal,
              toggleErrorModal,
              errorModalTitle,
              errorModalMessage,
              isSuccess,
            }) => (
              <React.Fragment>
                <ErrorModal
                  showErrorModal={showErrorModal}
                  toggleErrorModal={toggleErrorModal}
                  errorModalTitle={errorModalTitle}
                  errorModalMessage={errorModalMessage}
                  isSuccess={isSuccess}
                ></ErrorModal>
                {this.state.hasNewDesign ? (
                  <Error>
                    <NewApp
                      toggleErrorModal={toggleErrorModal}
                      topRef={this.topRef}
                    />
                  </Error>
                ) : (
                  <Error>
                    <div className="wrapper">
                      {!!this.style && (
                        <link
                          rel="stylesheet"
                          type="text/css"
                          href={this.style}
                          media="all"
                        ></link>
                      )}
                      <div className={contentWrappperClass}>
                        <Concurso
                          toggleErrorModal={toggleErrorModal}
                          preSelected={this.preSelected}
                          ProdutoID={this.state.ProdutoID}
                        />
                      </div>
                      <Messages />
                    </div>
                  </Error>
                )}
              </React.Fragment>
            )}
          </ErrorContext.Consumer>
        </ErrorProvider>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({ objUser: state.usuario.objUser });
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    { newSession, setCurrentTemplate, setIsNewDesign },
    dispatch
  );
export default connect(mapStateToProps, mapDispatchToProps)(App);



// WEBPACK FOOTER //
// ./src/main/app.jsx